import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import { Typography, Input, Tooltip } from "@mui/material";

const ENTER_KEY_CODE = 13;

type IEditableLabel = {
    initialValue: string;
    editable: boolean;
    onBlur: (value: string) => void;
    style?: any;
    className?: any;
};
const EditableLabel = (props: IEditableLabel) => {
    const { initialValue, editable, onBlur, style, className } = props;
    const [isEditing, setEditing] = useState(false);
    const [value, setValue] = useState(initialValue);
    const inputRef = useRef(null);

    const isTextValueValid = () => typeof value !== "undefined" && value.trim().length > 0;

    const handleFocus = () => {
        if (isEditing) {
            onBlur(value);
        }
        handleEditState();
    };

    const handleChange = (e: any) => {
        setValue(e.target.value);
    };

    const handleKeyDown = (e: any) => {
        if (e.keyCode === ENTER_KEY_CODE) {
            handleEnterKey();
        }
    };

    const handleEditState = () => {
        if (!editable) return;
        if (!isTextValueValid()) return;
        setEditing((prev) => !prev);
    };

    const handleEnterKey = () => {
        handleFocus();
    };

    if (isEditing) {
        return (
            <Input
                inputProps={{
                    ref: inputRef,
                    value,
                }}
                disableUnderline={true}
                className={className ? className : ""}
                onChange={handleChange}
                onBlur={handleFocus}
                onKeyDown={handleKeyDown}
                autoFocus
                style={{ ...style, width: 120, height: 20 }}
            />
        );
    }

    const labelText = isTextValueValid() ? value : initialValue;

    return (
        <Tooltip title={labelText}>
            <Typography onDoubleClick={handleFocus} style={{ ...style }} className={className ? className : ""}>
                {labelText}
            </Typography>
        </Tooltip>
    );
};

EditableLabel.propTypes = {
    initialValue: PropTypes.string.isRequired,
    emptyEdit: PropTypes.bool,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
};

export default EditableLabel;
